// import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { addWorkPlace, deleteWorkPlace, getAllWorkPlace, updateWorkPlace } from '../../redux/rtk/features/masters/workPlaceSlice';
// import PageTitle from '../page-header/PageHeader';


// const PlaceOfWorkMaster = () => {
//   const { Title } = Typography;
//   const [editingWorkPlace, setEditingWorkPlace] = useState(null);
//   const [form] = Form.useForm();
//   const dispatch = useDispatch();
//   const { list, loading } = useSelector((state) => state.workPlace);

//   useEffect(() => {
//     dispatch(getAllWorkPlace());
//   }, [dispatch]);

//   const handleOk = async () => {
//     try {
//       const values = await form.validateFields();
//       if (editingWorkPlace) {
//         // Update existing workPlaces
//         const result = await dispatch(
//           updateWorkPlace({ id: editingWorkPlace.id, values })
//         ).unwrap();
//         if (result.message === 'success') {
//           dispatch(getAllWorkPlace());
//         } else {
//           message.error('Error updating workPlaces!');
//         }
//       } else {
//         // Add new workPlaces
//         const result = await dispatch(addWorkPlace(values)).unwrap();
//         if (result.message === 'success') {
//           dispatch(getAllWorkPlace());
//         } else {
//           message.error('Error adding workPlaces!');
//         }
//       }
//       setEditingWorkPlace(null);
//     } catch (error) {
//       console.error('Validation failed or API error:', error);
//       // message.error('Failed to add or update workPlaces!');
//     }
//   };

//   // Handle deletion
//   const handleDelete = async (id) => {
//     try {
//       const result = await dispatch(deleteWorkPlace(id)).unwrap();
//       if (result?.message === 'success') {
//         dispatch(getAllWorkPlace()); // Refresh table data
//       } else {
//       }
//     } catch (error) {
//       console.error('Delete API error:', error);
//     }
//   };

//   // Table columns
//   const columns = [
//     {
//       title: 'Place of work',
//       dataIndex: 'workplace',
//       key: 'workplace',
//     },

//     {
//       title: 'Actions',
//       key: 'actions',
//       render: (_, record) => (
//         <>
//           <Button type="link" onClick={() => { setEditingWorkPlace(record); form.setFieldsValue(record); }}>
//             Edit
//           </Button>
//           <Popconfirm
//             title="Are you sure you want to delete this place of work?"
//             onConfirm={() => handleDelete(record.id)}
//             okText="Yes"
//             cancelText="No"
//           >
//             <Button type="link" danger>
//               Delete
//             </Button>
//           </Popconfirm>
//           <Button
//             type="link"
//             onClick={() => {
//               window.location.href = `/admin/placeOfWork/${record.id}`;
//             }}
//           >
//             Location
//           </Button>
//         </>
//       ),
//     },
//   ];

//   return (
//     <div>
//       <PageTitle title='Back' />
//       <Row gutter={16}>
//         <Col span={8}>
//           <Card title={editingWorkPlace ? 'Edit Work Place' : 'Add Work Place'}>
//             <Form
//               form={form}
//               style={{ marginBottom: "40px" }}
//               name="work-place-form"
//               labelCol={{ span: 10 }}
//               wrapperCol={{ span: 14 }}
//               onFinish={handleOk}
//               autoComplete="off"
//             >
//               <Form.Item
//                 name="workplace"
//                 label="Place of Work"
//                 rules={[{ required: true, message: 'Please enter a place of work!' }]}
//               >
//                 <Input placeholder="Enter place of work " />
//               </Form.Item>

//               <Button type="primary" block htmlType="submit">
//                 {editingWorkPlace ? 'Update Work Place ' : 'Add Work Place'}
//               </Button>
//             </Form>
//           </Card>
//         </Col>
//         <Col span={16}>
//           <Card title="Work Place List">
//             <Table
//               dataSource={list}
//               columns={columns}
//               rowKey="id"
//               loading={loading}
//               style={{ marginTop: 0 }}
//             />
//           </Card>
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export default PlaceOfWorkMaster;


import { Button, Card, Col, Form, Input, message, Modal, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addWorkPlace, deleteWorkPlace, getAllWorkPlace, updateWorkPlace } from '../../redux/rtk/features/masters/workPlaceSlice';
import PageTitle from '../page-header/PageHeader';
import WorkPlaceArea from '../settings/workPlaceAreaSetting';

const PlaceOfWorkMaster = () => {
  const { Title } = Typography;
  const [editingWorkPlace, setEditingWorkPlace] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.workPlace);
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
  const [selectedWorkPlaceId, setSelectedWorkPlaceId] = useState(null);

  useEffect(() => {
    dispatch(getAllWorkPlace());
  }, [dispatch]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingWorkPlace) {
        const result = await dispatch(
          updateWorkPlace({ id: editingWorkPlace.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllWorkPlace());
        } else {
          message.error('Error updating workPlaces!');
        }
      } else {
        const result = await dispatch(addWorkPlace(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllWorkPlace());
        } else {
          message.error('Error adding workPlaces!');
        }
      }
      setEditingWorkPlace(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteWorkPlace(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllWorkPlace());
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  const handleLocationClick = (recordId) => {
    setSelectedWorkPlaceId(recordId);
    setIsLocationModalOpen(true);
  };

  const columns = [
    {
      title: 'Place of work',
      dataIndex: 'workplace',
      key: 'workplace',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => { setEditingWorkPlace(record); form.setFieldsValue(record); }}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this place of work?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
          {/* <Button
            type="link"
            onClick={() => handleLocationClick(record.id)}
          >
            Location
          </Button> */}
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
          <Card title={editingWorkPlace ? 'Edit Work Place' : 'Add Work Place'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="work-place-form"
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
              <Form.Item
                name="workplace"
                label="Place of Work"
                rules={[{ required: true, message: 'Please enter a place of work!' }]}
              >
                <Input placeholder="Enter place of work " />
              </Form.Item>

              <Button type="primary" block htmlType="submit">
                {editingWorkPlace ? 'Update Work Place ' : 'Add Work Place'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Work Place List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>

      <Modal
        title="Office Location Management"
        open={isLocationModalOpen}
        onCancel={() => setIsLocationModalOpen(false)}
        width={1200}
        footer={null}
        destroyOnClose
      >
        <WorkPlaceArea 
          workPlaceId={selectedWorkPlaceId}
          onClose={() => setIsLocationModalOpen(false)}
        />
      </Modal>
    </div>
  );
};

export default PlaceOfWorkMaster;